import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col } from 'antd';

const Wrapper = styled.div`
  &&& {
    cursor: pointer;
    border-bottom: 1px solid #e0e0e0;
  }
`;

function ItemTicket({ name, last, id, openDialog, currentTiket }) {
  return (
    <Wrapper className="item-close">
      <div
        onClick={() => {
          openDialog(id);
        }}
        className={
          currentTiket === id
            ? 'item cursor-pointer pr-30 pl-60 pb-20 pt-20 bg-darkGray'
            : 'item cursor-pointer pr-30 pl-60 pb-20 pt-20 bg-white'
        }
      >
        <Row justify="space-between" align="middle">
          <Col span={20}>
            <div
              className={
                currentTiket === id
                  ? 'text-white'
                  : 'text-graytext'
              }
            >
              <div className="flex justify-between mb-12">
                <div className="border-b-1 border-dotted">{name}</div>
                <div className="text-12 ">{id}</div>
              </div>
              <div className="font-bold ">{last}</div>
            </div>
          </Col>
        </Row>
      </div>
    </Wrapper>
  );
}

ItemTicket.propTypes = {};

export default ItemTicket;
